// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Image, Flex, Text, useColorModeValue, useBreakpointValue } from '@chakra-ui/react';

// Assets
import { ReactComponent as PreIcon } from 'assets/svg/pre.svg';

const HomeSubHeader = () => {
    const bgDivider = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
    const data = [
        {
          text1: 'PRIZES EVERY MONTH',
          text2: 'SAVE AT EVERY PUMP',
          text3: 'MEMBERS PAY LESS',
          text4: 'AUSTRALIA`S FIRST',
        }
    ];

    const isFontSize = useBreakpointValue({ base: '12px', md: '16px' });

    const styleText = {
        color: '#FFF',
        fontSize: isFontSize,
        fontStyle: 'normal',
        fontWeight: '700',
        textTransform: 'uppercase'
    };

    const listToRight = useAnimation();
    useEffect(() => {
        const animateRight = async () => {
            await listToRight.start({
                x: ['-100%', '0%'],
                transition: { duration: 50, ease: 'linear', repeat: Infinity, repeatType: 'reverse' },
            });
        };

        animateRight();

        return () => listToRight.stop();
    }, [listToRight]);

    return (
        <>
            <Box 
                zIndex="1" 
                overflow="visible"
                width="100vw" 
                mb="0px" 
                bg="#099BFF" 
                whiteSpace="nowrap" 
                position="relative">
                <motion.div
                    style={{ display: 'flex', gap: '0px' }}
                    animate={listToRight}
                    initial={{ x: '-100%' }}
                >
                    {Array(40).fill(data).flat().map((item, index) => (
                        <Box 
                            key={`bottom-${index}`} 
                            p="0px" 
                            bg="#099BFF" 
                            overflow="hidden"
                            minW={{base: '628px', md: '794px'}}
                            py={{base: '5px', md: '13px'}}
                            h={{base: '24px', md: '44px'}}
                            w="100%" 
                            textAlign="center">
                            <Flex gap="10px" alignItems="center" position="relative">
                              <PreIcon />
                              <Text style={styleText}>{item?.text1}</Text>

                              <PreIcon />
                              <Text style={styleText}>{item?.text2}</Text>

                              <PreIcon />
                              <Text style={styleText}>{item?.text3}</Text>

                              <PreIcon />
                              <Text style={styleText}>{item?.text4}</Text>
                            </Flex>
                        </Box>
                    ))}
                </motion.div>
            </Box>
        </>
    );
};

export default HomeSubHeader;